import React from "react";
import { Route, Switch } from "react-router-dom";
import HomePage from "./home/HomePage";
import AboutPage from "./about/AboutPage";
import Header from "./common/Header";
import Footer from "./common/Footer";
import PageNotFound from "./PageNotFound";
import GoToTop from "./common/scroll/GoToTop";
import JavaHome from "./java/JavaHomePage";
import PythonHome from "./python/PythonHomePage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="container-fluid mainApp">
      <Header />
      <div className="topRouterWrapper">
        <div className="overlay"/>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route path="/about" component={AboutPage} />
          <Route path="/javaHome/:page?" component={JavaHome} />
          <Route path="/pythonHome/:page?" component={PythonHome} />
          <Route component={PageNotFound} />
        </Switch>
      </div>
      <Footer />
      <GoToTop scrollStepInPx={100} delayInMs={10}/>
      <ToastContainer autoClose={3000} hideProgressBar />
    </div>
  );
}

export default App;
